export default "__VITE_ASSET__CgPIQL70__"